import React, { FunctionComponent, PropsWithChildren } from 'react';

import { default as MuiTable, TableProps } from '@mui/material/Table';

const Table: FunctionComponent<TableProps> = (
  props: PropsWithChildren<TableProps>
) => {
  return <MuiTable {...props}>{props.children}</MuiTable>;
};

export default Table;
